import React from 'react';
import {motion} from 'framer-motion';
import {
    PaddingContainer,
    FlexContainer,
    Heading,
    ParaText,
    BlueText,
    IconContainer,
    Text,

} from '../styles/Global.styled';
import {BsLinkedin,BsInstagram} from "react-icons/bs";
import { FaGithub } from 'react-icons/fa'
import { ShowcaseParticleContainer, ShowcaseImageCard,Particle } from '../styles/Showcase.styled';
import { Picture, Button} from '../styles/Global.styled';

import FotoPerfil from '../assets/FotoDePerfil.jpg';
import { fadeInLeftVariant,fadeInRightVariant, fadeInTopVariant } from '../utils/Variants';
import HeaderTyping from './ui/HeaderTyping';
const Showcase = () => {
  return (
    <PaddingContainer 
        id="about-me"
        top="15%"
        bottom="10%"
        left="8%"
        right="8%"
        tabletLeft="2%"
        tabletRight="2%"
        responsiveLeft='1rem'
        responsiveRight='1rem'
        responsiveTop='8rem'
        
    > 
           
       
        <FlexContainer align="left" fullWidthChild gap="70px"  isAbout>
            {/** --left content-- */} 
            <motion.div 
                variants={fadeInLeftVariant}
                initial='hidden'
                whileInView='visible'
                viewport={{ once: false, amount: 0.6 }}> 
                    <PaddingContainer bottom='10px'>
                    <Heading size='h4' align='left'>
                            <Text weight='bolder' >Una breve introducción</Text>
                    </Heading>
                    <Heading  size='h2' align='left'>
                             <Text weight='bolder' >  Sobre <BlueText>  Mí</BlueText></Text> 
                    </Heading>
                    </PaddingContainer>
                    <PaddingContainer top='10px'>
                    <ParaText>
                        <Text weight='bolder' > <BlueText>Desde pequeño </BlueText></Text>
                        he sido un fanático de la tecnología, por lo que escogí una carrera en donde pueda
                        aprender y desarrollarme en dicha área. 
                     </ParaText>
                    <ParaText> En la carrera nos introdujeron a <Text weight='bold'> <BlueText> la programación</BlueText></Text>, y ahí todo cambió: descubrí que no solo era una herramienta, sino una forma de expresarme, 
                                de dar vida a ideas y resolver problemas a mi manera. 
                    </ParaText>
                    </PaddingContainer>     
                
                {/**  --social icons-- */}
                
            </motion.div >
             {/**   --right content--   */}
             <motion.div  
                variants={fadeInRightVariant} 
                initial='hidden' 
                whileInView='visible'
                viewport={{ once: false, amount: 0.6 }}>
                <FlexContainer justify="flex-end" align='center' direction='column' gap='90px' >
                   
                         <FlexContainer direction="row" align="center" gap="20px">
                             <PaddingContainer tabletBottom='60px' tabletTop='40px'>
                             <Picture src={FotoPerfil}/>
                             </PaddingContainer>
                         </FlexContainer>
                         <a href="/assets/CV_FABIAN.pdf" download 
                        style={{ position: "relative", bottom:'40px',right:'1px' }}><Button>Descargar CV 📑</Button></a> 
                    
                </FlexContainer>
             </motion.div>
        </FlexContainer>
    </PaddingContainer>
  )
}

export default Showcase